import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row, Table , Button, Popover, PopoverBody} from "reactstrap";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import { useHistory, useParams } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";

import orderReducer from "../store";
import Breadcrumb from "../../../layout/breadcrumb";
import withReducer from "../../../store/withReducer";
import { claimOfferResponseToTable } from "../../../utils/mapper";
import PreLoader from "../../../share-components/ui/preLoader";
import ModalFormSubmit from "../../../share-components/form/modalFormSubmit";
import CommonDataTable from "../../../share-components/table/commonDataTable";

import ReturnProcessTimeline from "../pending-return/view/content/ReturnProcessTimeline";
import OutOfStockEmailModal from "../return/content/outOfStockEmailModal";

import { TrackOrder } from "./section/trackOrder";
import { ShippingInformation } from "./section/shippingInformation";
import { BillingInformation } from "./section/billingInformation";
import { UkOrder } from "./section/ukOrder";
import { Item } from "./section/item";
import { RefundedItem } from "./section/refundedItem";
import ReportContent from "./section/reportContents";
import OrderCancelForm from "./content/orderCancelForm";
import ClaimOfferForm from "./section/claimOfferForm";

import {
  getTrackingItem, setOrderData, setOrderTrackingDetils, setReturnOrderData, setTrackingData,
  showOrder, showTrackingInvoice, syncOrderTracking, getOutOfStockEmailTemplate, sendOutOfStockEmail, setInvoiceSalesReturnData,
  cancelOrder, closeOrderCancelDialog,
  claimOffer, closeNewClaimOffeDialog, deleteClaimOffer, downloadTrackingInvoice, openNewClaimOfferDialog, openNewTrackingDialog, updateClaimOffer,
} from "../store/orderSlice";

const defaultDeleteOrderValues = {
    reason: null, 
    notify_customer: false,
    staff_note: '',
};

const deleteOrderschema = yup.object().shape({
    reason: yup.object().nullable().required('Cancellation reason is required'),
    notify_customer: yup.boolean(),
    staff_note: yup.string().nullable(),
});

const defaultValues = {
    claim_ref_no: '',
    claim_date: '',
    claim_status: '',
    claimed_by: '',
};

const claimStatus = [
  { id: 0, name: "Won" },
  { id: 1, name: "Loss" },
  { id: 2, name: "Decision Pending" },
];

export const schema = yup.object().shape({
  claim_ref_no: yup
    .string()
    .required("Reference number is required"),

  claim_date: yup
    .date()
    .typeError("Please select a valid date & time")
    .required("Claim date is required"),

  claim_status: yup
    .mixed()
    .nullable(), 

  claimed_by: yup
    .mixed()
    .nullable(), 
});

const ViewOrder = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  let history = useHistory();
  const [loading, isSetLoading] = useState(false);
  const [syncButtonDisabledMap, setSyncButtonDisabledMap] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(false);
  const orderState = useSelector(({ order }) => order.order);
  const userState = useSelector(({ authReducer }) => authReducer.data);
  const authData = useSelector(({ authReducer }) => authReducer);
  const [outOfStockModalOpen, setOutOfStockModalOpen] = useState(false);
  const [outOfStockEmailData, setOutOfStockEmailData] = useState(null);
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  const {handleSubmit: cancelOrderHandleSubmit, formState : cancelOrderFormState, reset : cancelOrderReset, control :cancelOrderControl, register :cancelOrderRegister, setValue :cancelOrderSetValue, handleChange :cancelOrderHandleChange, trigger :cancelOrderTrigger, getValues : cancelOrderGetValues} = useForm({
      mode: 'onChange',
      defaultDeleteOrderValues,
      resolver: yupResolver(deleteOrderschema)
  });
  
  const {cancelOrdererrors} = cancelOrderFormState;

  const [claimOffersData, setClaimOffersData] = useState([]);
  const dataMenu = [
    {
      type: 1,
      text: "Orders",
      link: "/order",
    },
    {
      type: 0,
      text: "View Order",
    },
  ];

  const { handleSubmit, formState, control, reset, register, setValue, getValues, trigger, watch } = useForm({
      mode: 'onChange',
      defaultValues,
      resolver: yupResolver(schema)
  });
  
  const { errors } = formState;

  useEffect(() => {
    isSetLoading(true);
    if (id !== undefined) {
      const data = {
        id,
        params: { seller: authData.defaultSeller?.value },
      };

      dispatch(showOrder(data)).then((res) => {
        if (!res.error) {
          isSetLoading(false);
          dispatch(setReturnOrderData(res.payload));
          dispatch(setOrderData(res.payload));
          dispatch(setInvoiceSalesReturnData(res.payload.partner_invoice_actions))
        }
        isSetLoading(false);
      });
    }
  }, [dispatch, authData.defaultSeller, id]);

  const openOutOfStockEmailModal = (selectedItemIds = []) => {
    const items = (orderState?.list || [])
      .filter(item => selectedItemIds.includes(item.id))
      .map(item => ({
        brand: item.brand,
        product_title: item.name || item.title,
        product_sku: item.sku,
        product_image: item.image,
        return_quantity: item.quantity,
        return_amount: item.price || item.total_price_numeric || 0
      }));

    if (!items.length) {
      toast.error("Please select at least one item.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 4000
      });
      return;
    }

    dispatch(getOutOfStockEmailTemplate({ 
      order_id: id,
      items 
    })).then(res => {
      if (!res.error) {
        const payload = res.payload?.data ? res.payload.data : res.payload;
        
        if (!payload.order_id) {
          payload.order_id = id;
        }
        
        setOutOfStockEmailData(payload);
        setOutOfStockModalOpen(true);
      } else {
        toast.error("Failed to load email template", { position: toast.POSITION.TOP_RIGHT });
      }
    });
  };

  const closeOutOfStockEmailModal = () => {
    setOutOfStockModalOpen(false);
    setOutOfStockEmailData(null);
  };

  const onSendOutOfStockEmail = (payload) => {
    setIsSendingEmail(true);
    dispatch(sendOutOfStockEmail(payload)).then(res => {
      setIsSendingEmail(false);
      if (!res.error) {
        closeOutOfStockEmailModal();
      }
    });
  };

  const handleOpenEmailFromSelection = (selectedItems) => {
    openOutOfStockEmailModal(selectedItems);
  };
  
  useEffect(() => {
    if (!orderState?.tracking_list) return;

    if (claimOffersData.length > 0) return; // <-- prevent overwriting
    
    const key = Object.keys(orderState.tracking_list)[0];
    const trackingItem = orderState.tracking_list[key]?.[0];

    setClaimOffersData(trackingItem?.claim_offers || []);
  }, [orderState]);


  const retrieveTrackingDetails = (id) => {
    dispatch(getTrackingItem(id)).then((res) => {
      if (!res.error) {
        dispatch(setTrackingData(res.payload));
      }
    });
  };

  const fetchView = () => {        
      dispatch(showTrackingInvoice(id)).then(res => {
          if (!res.error) {
              dispatch(setOrderTrackingDetils(res.payload));
              isSetLoading(false);
          }
      });
  }

  const syncTrackingClick = (tracking_id) => {
      setSyncButtonDisabledMap(prev => ({ ...prev, [tracking_id]: true }));
          const payload = {
          tracking_id: tracking_id
      }
      dispatch(syncOrderTracking({ ...payload })).then(res => {
          setSyncButtonDisabledMap(prev => ({ ...prev, [tracking_id]: false }));
          fetchView();
      });
  }

  const PopoverSyncTracking = (props) => {
    const {list} = props;
    const [popover, setPopover] = useState(false)
    const Toggle = () => setPopover(!popover);
    return (
        <>
            <Button color="primary" size="xs" type="button" className="" id={"SyncTrackingPopover-" + list.tracking.id} 
                onClick={() => {
                    syncTrackingClick(list.tracking.id)
                }} 
                disabled={syncButtonDisabledMap[list.tracking.id] || list.can_sync_tracking_status == 2}>
                    {syncButtonDisabledMap[list.tracking.id] && <i className="fa fa-spinner fa-spin" />} Fetch Tracking Status
            </Button>
            {(list.can_sync_tracking_status == 2) && (
                <Popover
                    placement="top"
                    isOpen={popover}
                    target={"SyncTrackingPopover-" + list.tracking.id}
                    toggle={Toggle}
                    trigger="hover"
                >
                    <PopoverBody>
                        You have reached the usage limit for today. Please try again tomorrow.
                    </PopoverBody>
                </Popover>
            )}
        </>
    );
  };

  const onSubmitForm = (dialog, data) => {
    const orderId = Number(dialog.id)

    const cancelData = {
      reason: data.reason.id,
      notify_customer: data.notify_customer,
      staff_note: data.staff_note
    }

    setButtonDisable(true)
    dispatch(cancelOrder({ orderId, cancelData })).then(res => {
      setButtonDisable(false)
      dispatch(closeOrderCancelDialog());
      toast.success("Order cancelled successfully.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      history.push(`/order`);
    })
  }

  const closeDialog = () => {
    dispatch(closeOrderCancelDialog());
  };

  const onSubmitOfferClaimForm = (dialog, data) => {
    const invoiceNo = dialog.data.subject_id;
    const trackingId = dialog.data.tracking_id;

    if(data.id){
      const offerData ={
        id: data.id,
        order_id: data.orderId,
        subject_id: data.subjectId,
        tracking_id: data.trackingTableId,
        claim_ref_no: data.claim_ref_no,
        claim_date: data.claim_date ? (moment(data.claim_date).format('YYYY-MM-DD HH:mm:ss')) : null,
        claim_status: data.claim_status.id,
        claimed_by: data.claimed_by.value,
      }

      setBtnDisabled(true)
      dispatch(updateClaimOffer(offerData)).then(res => {
        setBtnDisabled(false)

        if (!res.error) {
          setClaimOffersData(res.payload.data)
          onClaimOfferClose();
        }
      });

    } else {
      const offerData = {
        id,
        invoice_no: invoiceNo,
        tracking_id: trackingId,
        claim_ref_no: data.claim_ref_no,
        claim_date: data.claim_date ? (moment(data.claim_date).format('YYYY-MM-DD HH:mm:ss')) : null,
        claim_status: data.claim_status.id,
        claimed_by: data.claimed_by.value,
      }

      setBtnDisabled(true)
      dispatch(claimOffer(offerData)).then(res => {
        setBtnDisabled(false)
        if (!res.error) {
          setClaimOffersData(res.payload.data)
          onClaimOfferClose();
        }
      });
    }
  }

  const onClaimOfferClose = () => {
    dispatch(closeNewClaimOffeDialog());
  }

  const tableColumns = [
    {
      name: 'Ref No',
      selector: row => row.refNo,
      sortable: true,
      left: true,
    },
    {
      name: 'Claimed Date',
      selector: row => row.claimDate
        ? moment(row.claimDate).format("DD MMM YYYY hh:mm:ss")
        : "-",
      sortable: true,
      left: true,
    },
    {
      name: 'Claimed Status',
      selector: (row) => {
        const status = claimStatus.find(s => s.id === Number(row.claimStatus));
        return status ? status.name : "-";
      },
      sortable: true,
      left: true,
    },
    {
      name: 'Claimed by',
      selector: row => row.claimBy ? row.claimBy.name : "",
      sortable: true,
      left: true,
    }
  ]

  const onEdit = (row) => {
    const isEdit = true
    dispatch(openNewClaimOfferDialog({ row, isEdit: true }));
  };

  const onDelete = (row) => {
    const cliamId = row.id || null;

    if (!row) return null;


    setBtnDisabled(true)
    dispatch(deleteClaimOffer(row.id)).then(res => {
      setBtnDisabled(false)
      if (!res.error) {
        setClaimOffersData(res.payload.data)
        onClaimOfferClose();
      }
    });
  }

  return (
    <>
      {loading ? (
        <PreLoader />
      ) : (
        <Fragment>
          <Breadcrumb title="Orders" data={dataMenu} />
          <Container fluid={true}>
            <Row>
              <Col sm={3}>
                <TrackOrder orderState={orderState} />
                <ShippingInformation colSize={12} orderState={orderState} />
                <BillingInformation colSize={12} orderState={orderState} />
                <UkOrder colSize={12} orderId={id} canCreate={userState.user.role.name != "Seller"} />
              </Col>
              <Col sm={9}>
                <Item
                  retrieveTrackingDetails={retrieveTrackingDetails}
                  orderId={id}
                  orderState={orderState}
                  authData={authData}
                  onSendEmail={handleOpenEmailFromSelection}
                />

                {userState.user.role.name != "Seller" && (
                  <>
                    <Col md={12}>
                      <RefundedItem orderState={orderState} />
                    </Col>
                  </>
                )}

                {orderState.trackingDetails ? orderState.trackingDetails.length > 0 && (
                    <Row style={{paddingLeft:15, paddingRight:15}}>

                        <Col sm={12}>
                            {orderState?.tracking_list && (() => {
                                // Flatten arrays in the exact order they appear in JSON
                                const allItems = Object.entries(orderState.tracking_list)
                                    .reduce((acc, [_, arr]) => acc.concat(arr || []), []);

                                // If you still want sorting by invoice_no (ignore "CG" prefix)
                                const sortedItems = [...allItems].sort((a, b) => {
                                    const numA = parseInt(a.invoice_no.replace("CG", ""), 10);
                                    const numB = parseInt(b.invoice_no.replace("CG", ""), 10);
                                    return numA - numB;
                                });

                                return sortedItems.map((list, index) => {
                                    if (!list?.tracking && !list?.tracking_summary) return null;

                                    return (
                                        <Card className="ribbon-wrapper" key={`${list.invoice_no || 'no-inv'}-${index}`}>
                                            <CardBody>
                                                <div className="ribbon ribbon-clip h6 ribbon-info">
                                                    {list.seller_name} (Invoice No: {list.invoice_no})
                                                </div>

                                                {(list.tracking && list.tracking.tracking_number) ? (
                                                    <div className="table-responsive">
                                                        <Table style={{ width: '100%', border: "none" }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ width: '50%', paddingLeft: 0 }}>
                                                                        <p><strong>Tracking Details:</strong></p>
                                                                        <p><strong>Carrier:</strong> {list.tracking.tracking_name}</p>
                                                                        <p><strong>Tracking Number:</strong> {list.tracking.tracking_number}</p>
                                                                        <p>
                                                                            <strong>Tracking URL:</strong>{" "}
                                                                            <a
                                                                                style={{ textDecoration: 'underline', color: 'blue' }}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                href={list.tracking.tracking_url}
                                                                            >
                                                                                {list.tracking.tracking_url}
                                                                            </a>
                                                                        </p>
                                                                        {list.can_sync_tracking_status != 0 && (
                                                                            <p><PopoverSyncTracking list={list}/></p>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                    <p>
                                                                      <strong style={{ width: "50px" }}>Offer :</strong>{" "}
                                                                      <a
                                                                        target="_blank"
                                                                        onClick={() => {
                                                                          let row ={
                                                                              invoice_no: list.invoice_no,
                                                                              tracking_id: list?.tracking?.id,
                                                                              subject_id: orderState?.trackingDetails[0]?.id,
                                                                          }
                                                                          dispatch(
                                                                            openNewClaimOfferDialog({ row , isEdit: false
                                                                              
                                                                            })
                                                                          );
                                                                        }}
                                                                        className="pt-1 btn btn-xs btn-info"
                                                                      >
                                                                        Make a Claim
                                                                      </a>
                                                                    </p>
                                                                  </td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                ) : (
                                                    <div className="table-responsive">
                                                        Couldn't fetch Tracking details.
                                                    </div>
                                                )}

                                                {list.tracking_summary && (
                                                    <div className="mt-2 mb-5">
                                                        <h6>Tracking Status:</h6>
                                                        <ReturnProcessTimeline trackingSummary={list.tracking_summary} />
                                                    </div>
                                                )}
                                            </CardBody>
                                        </Card>
                                    );
                                });
                            })()}


                        </Col>
                       {claimOffersData.length > 0 && (     
                        <Col sm={12}>
                          <Card >
                              <CardBody>
                                <div className="table-responsive product-table mt-4">
                                  <CommonDataTable
                                      headerColumns={tableColumns}
                                      gridData={claimOfferResponseToTable(claimOffersData)}
                                      pagination
                                      onEdit={onEdit}
                                      onDelete={onDelete}
                                      />
                                </div>
                            </CardBody>
                          </Card>
                      </Col>)}
                    </Row>
                ) : ""}

                <ReportContent orderState={orderState}/>
              </Col>
            </Row>
          </Container>

          <OutOfStockEmailModal
            isOpen={outOfStockModalOpen}
            emailData={outOfStockEmailData}
            onSend={onSendOutOfStockEmail}
            onClose={closeOutOfStockEmailModal}
            isSending={isSendingEmail}
          />

          <ModalFormSubmit
                defaultValues={defaultDeleteOrderValues}
                schema={deleteOrderschema}
                onSubmitForm={onSubmitForm}
                reset={cancelOrderReset}
                formState={cancelOrderFormState}
                handleSubmit={cancelOrderHandleSubmit}
                customTitle
                customTitleText="Cancel Order"
                selector='order'
                dialog={({order}) => order.order.addOrderCancelDialog}
                closeDialog={closeDialog}
                publish={false}
                setValue={cancelOrderSetValue}
                getValues={cancelOrderGetValues}
                falsePublishButtonText="Cancel Order"
                // btnText={btnText}
                // publishValue={publishValue}
                // saveValue={saveValue}
                buttonDisable={buttonDisable}
            >
                <OrderCancelForm  control={cancelOrderControl} errors={cancelOrdererrors} register={cancelOrderRegister} setValue={cancelOrderSetValue} trigger={cancelOrderTrigger} getValues={cancelOrderGetValues}/>
            </ModalFormSubmit>

          <ModalFormSubmit
              defaultValues={defaultValues}
              schema={schema}
              onSubmitForm={onSubmitOfferClaimForm}
              reset={reset}
              formState={formState}
              handleSubmit={handleSubmit}
              btnDisabled={btnDisabled}
              loadingBtn
              title='Claim Offer Form'
              selector='order'
              dialog={({ order }) => order.order.claimOfferDialog}
              closeDialog={onClaimOfferClose}
          >
              <ClaimOfferForm orderState={orderState} register={register} errors={errors} setValue={setValue} trigger={trigger} getValues={getValues} watch={watch}/>
          </ModalFormSubmit>
        </Fragment>
      )}
    </>
  );
};

export default withReducer([{ order: orderReducer }])(ViewOrder);
